export default __webpack_public_path__ + "static/media/Gida of the Judgment Bolt.2bacc9e1.jpg";